import { Loader2 } from 'lucide-react';
import { cn } from '@/utils/cn';

export function Spinner({ className, label }: { className?: string; label?: string }) {
  return (
    <span role="status" className="inline-flex items-center gap-2">
      <Loader2 className={cn('text-muted size-5 animate-spin', className)} aria-hidden />
      <span className="sr-only">{label ?? 'Loading'}</span>
    </span>
  );
}

export function PageSpinner({ label }: { label?: string }) {
  return (
    <div className="flex min-h-64 w-full items-center justify-center">
      <Spinner label={label} />
    </div>
  );
}
